import DataService from '../DataService.js';
import EventBusService from '../EventBusService.js';
import { canTransitionDockAppointment, DockAppointmentUpdateSchema } from '@kairos/types';

const GATE_IN  = 'gate_in';
const GATE_OUT = 'gate_out';

async function _handleGateIn({ tenantId, trailerId, eventTime }) {
  if (!tenantId || !trailerId) return;

  const matches = await DataService.query(
    'dock_appointments',
    { tenantId, yardTrailerId: trailerId, softDeleted: false },
    tenantId,
  );

  const appt = matches.find(a => a.status === 'confirmed');
  if (!appt) return;

  if (!canTransitionDockAppointment(appt.status, 'checked_in')) return;

  await DataService.setTyped(
    'dock_appointments',
    appt.id,
    { status: 'checked_in', gateInAt: eventTime || new Date().toISOString() },
    DockAppointmentUpdateSchema,
    'pylon',
  );

  await EventBusService.publish({
    eventType: 'pylon.appointment.checked_in',
    tenantId,
    sourceModule: 'pylon',
    sourceId: appt.id,
    actor: 'pylon',
    payload: { appointmentId: appt.id, trailerId, gateInAt: eventTime },
  });
}

async function _handleGateOut({ tenantId, trailerId, eventTime, dwellMinutes }) {
  if (!tenantId || !trailerId) return;

  const matches = await DataService.query(
    'dock_appointments',
    { tenantId, yardTrailerId: trailerId, softDeleted: false },
    tenantId,
  );

  const appt = matches.find(a => a.status === 'in_progress');
  if (!appt) return;

  if (!canTransitionDockAppointment(appt.status, 'completed')) return;

  const now = eventTime || new Date().toISOString();
  const computed = dwellMinutes != null
    ? dwellMinutes
    : appt.gateInAt
      ? Math.round((new Date(now) - new Date(appt.gateInAt)) / 60000)
      : null;

  await DataService.setTyped(
    'dock_appointments',
    appt.id,
    { status: 'completed', gateOutAt: now, completedAt: now, dwellMinutes: computed },
    DockAppointmentUpdateSchema,
    'pylon',
  );

  await EventBusService.publish({
    eventType: 'pylon.appointment.completed',
    tenantId,
    sourceModule: 'pylon',
    sourceId: appt.id,
    actor: 'pylon',
    payload: { appointmentId: appt.id, trailerId, gateOutAt: now, dwellMinutes: computed },
  });
}

export function subscribeToYardGateEvents() {
  return EventBusService.subscribe('wms.yard.gate_event', async (event) => {
    const { tenantId, payload } = event;
    const { gateEventType, trailerId, eventTime, dwellMinutes } = payload || {};

    try {
      if (gateEventType === GATE_IN) {
        await _handleGateIn({ tenantId, trailerId, eventTime });
      } else if (gateEventType === GATE_OUT) {
        await _handleGateOut({ tenantId, trailerId, eventTime, dwellMinutes });
      }
    } catch (err) {
      console.error('[pylon] gate event handler error:', err?.message);
    }
  });
}
